<div class="container">
  <div class="order-navigation-header">
    <button
      mat-flat-button
      color="primary"
      [disabled]="!(prevOrderId$ | async)"
      (click)="navigateToPrevOrder()">
      Previous Order
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!(nextOrderId$ | async)"
      (click)="navigateToNextOrder()">
      Next Order
    </button>
  </div>

  <div class="card header">
    <div class="top">
      <div class="section">
        <h3>Order #O_{{ orderId$ | async }}</h3>
        <h1>{{ (order$ | async)?.name }}</h1>
      </div>

      <div class="section actions">
        <div class="quick-change-action">
          <p>Source</p>

          <button
            mat-flat-button
            [ngStyle]="{
              'background-color':
                (order$ | async)?.orderSource?.hexColor ?? '#ffffff',
              color: getTextColorForBackground(
                (order$ | async)?.orderSource?.hexColor ?? '#ffffff'
              )
            }"
            [matMenuTriggerFor]="orderSourceMenu">
            {{ (order$ | async)?.orderSource?.name }}
          </button>
          <mat-menu #orderSourceMenu class="like-select" xPosition="before">
            @for (option of orderSources$ | async; track option.id) {
              <button
                mat-flat-button
                [ngStyle]="{
                  'background-color': option?.hexColor ?? '#ffffff',
                  color: getTextColorForBackground(
                    option?.hexColor ?? '#ffffff'
                  )
                }"
                (click)="updateOrderSource(option.id)">
                {{ option.name }}
              </button>
            }
          </mat-menu>
        </div>

        <div class="quick-change-action">
          <p>Status</p>

          <button
            mat-flat-button
            [ngStyle]="{
              'background-color':
                (order$ | async)?.orderStatus?.hexColor ?? '#ffffff',
              color: getTextColorForBackground(
                (order$ | async)?.orderStatus?.hexColor ?? '#ffffff'
              )
            }"
            [matMenuTriggerFor]="orderStatusMenu">
            {{ (order$ | async)?.orderStatus?.name }}
          </button>
          <mat-menu #orderStatusMenu class="like-select" xPosition="before">
            @for (option of orderStatuses$ | async; track option.id) {
              <button
                mat-flat-button
                [ngStyle]="{
                  'background-color': option?.hexColor ?? '#ffffff',
                  color: getTextColorForBackground(
                    option?.hexColor ?? '#ffffff'
                  )
                }"
                (click)="updateOrderStatus(option.id)">
                {{ option.name }}
              </button>
            }
          </mat-menu>
        </div>

        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #actionsMenu="matMenu" class="menu">
          <button mat-flat-button (click)="openEditForm()">
            <mat-icon iconPositionEnd>edit</mat-icon> Edit
          </button>
          <button mat-flat-button (click)="promptDeleteItem()">
            <mat-icon iconPositionEnd>delete</mat-icon> Delete
          </button>
        </mat-menu>
      </div>
    </div>

    <aa-data-table [tableConfig]="summaryTableConfig"> </aa-data-table>

    @if (!(isNewFlow$ | async)) {
      <div class="drafted-changes-settings">
        <!-- order-level change email (old flow) -->
        <div class="initial-actions">
          <button
            id="send-changes-email-button"
            mat-raised-button
            matTooltip="Send Requested Changes Email"
            (click)="sendChangeEmail()">
            Send Changes to Customer
            <mat-icon iconPositionEnd>send</mat-icon>
          </button>
        </div>

        @if (
          (order$ | async)?.hasPendingServiceChanges ||
          ((order$ | async)?._count?.orderServiceLinkages ?? 0) > 0 ||
          ((order$ | async)?._count?.orderCards ?? 0) > 0 ||
          ((order$ | async)?._count?.invoices ?? 0) > 0
        ) {
          <div class="after-actions">
            @if ((order$ | async)?.changesSentAt) {
              <div class="status">
                @if ((order$ | async)?.changesApproved == true) {
                  <p class="change-status approved">Changes Approved</p>
                } @else if ((order$ | async)?.changesApproved == false) {
                  <p class="change-status rejected">Rejected</p>
                } @else {
                  <p class="change-status drafted">Changes Awaiting Approval</p>
                }
              </div>
            }
          </div>
          @if ((order$ | async)?.changesSentAt) {
            <p>Sent At: {{ formatDateTime((order$ | async)?.changesSentAt) }}</p>
          }
          @if ((order$ | async)?.changesApprovedUpdatedAt) {
            @if ((order$ | async)?.changesApproved) {
              <p>
                Approved At :
                {{ formatDateTime((order$ | async)?.changesApprovedUpdatedAt) }}
              </p>
            } @else if ((order$ | async)?.changesApproved == false) {
              <p>
                Rejected At :
                {{ formatDateTime((order$ | async)?.changesApprovedUpdatedAt) }}
              </p>
            }
          }
        }
      </div>
    }
  </div>

  @if (isNewFlow$ | async) {
    <div class="card card-changes-card">
      <h2>Card Changes</h2>

      @for (entry of cardsWithUnsentChanges$ | async; track entry.card.id) {
        <div class="card-change-entry">
          <div class="card-change-header">
            <strong>{{ entry.card.label }} (#C_{{ entry.card.id }})</strong>
            <button mat-icon-button [matMenuTriggerFor]="unsentMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #unsentMenu="matMenu">
              <button mat-menu-item (click)="clearDraftChangesForCard(entry.card.id)">
                <mat-icon>delete</mat-icon> Clear Draft Changes
              </button>
            </mat-menu>
          </div>
          <div class="card-change-details">
            @if (entry.addedServices.length) {
              <div class="service-list added">
                <p class="service-list-label">Added Services:</p>
                @for (service of entry.addedServices; track service.name) {
                  <span class="service-item added">
                    + {{ service.name }}
                    ({{ service.price | currency: 'USD' }})
                  </span>
                }
              </div>
            }
            @if (entry.removedServices.length) {
              <div class="service-list removed">
                <p class="service-list-label">Removed Services:</p>
                @for (service of entry.removedServices; track service.name) {
                  <span class="service-item removed">
                    - {{ service.name }}
                    ({{ service.price | currency: 'USD' }})
                  </span>
                }
              </div>
            }
            <p class="net-change" [ngClass]="{
              positive: entry.netChange > 0,
              negative: entry.netChange < 0
            }">
              Net Change: {{ entry.netChange >= 0 ? '+' : '' }}{{ entry.netChange | currency: 'USD' }}
            </p>
          </div>
          <div class="card-change-actions">
            <button
              mat-raised-button
              color="accent"
              (click)="notifyCustomerOfCardChanges(entry.card.id)">
              Notify Customer
              <mat-icon iconPositionEnd>send</mat-icon>
            </button>
          </div>
        </div>
      }

      @for (entry of cardsWithPendingApproval$ | async; track entry.card.id) {
        <div class="card-change-entry pending">
          <div class="card-change-header">
            <strong>{{ entry.card.label }} (#C_{{ entry.card.id }})</strong>
            <button mat-icon-button [matMenuTriggerFor]="pendingMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #pendingMenu="matMenu">
              <button mat-menu-item (click)="cancelAndClearDraftChangesForCard(entry.card.id)">
                <mat-icon>delete</mat-icon> Cancel & Clear Draft Changes
              </button>
            </mat-menu>
          </div>
          <span class="change-status drafted">Awaiting Customer Approval</span>
          <div class="card-change-details">
            @if (entry.addedServices.length) {
              <div class="service-list added">
                <p class="service-list-label">Added Services:</p>
                @for (service of entry.addedServices; track service.name) {
                  <span class="service-item added">
                    + {{ service.name }}
                    ({{ service.price | currency: 'USD' }})
                  </span>
                }
              </div>
            }
            @if (entry.removedServices.length) {
              <div class="service-list removed">
                <p class="service-list-label">Removed Services:</p>
                @for (service of entry.removedServices; track service.name) {
                  <span class="service-item removed">
                    - {{ service.name }}
                    ({{ service.price | currency: 'USD' }})
                  </span>
                }
              </div>
            }
          </div>
          <div class="card-change-actions">
            <button
              mat-raised-button
              (click)="viewCardInChat(entry.card.id)">
              View in Chat
              <mat-icon iconPositionEnd>chat</mat-icon>
            </button>
          </div>
        </div>
      }

      @if (!(cardsWithUnsentChanges$ | async)?.length && !(cardsWithPendingApproval$ | async)?.length) {
        <p class="no-changes">No pending card changes.</p>
      }
    </div>
  }

  <div class="card">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      animationDuration="0ms"
      (selectedIndexChange)="selectedIndexChanged($event)">
      <!-- cards -->
      <mat-tab label="Cards">
        @if ((currentTabIndex$ | async) == 0) {
          <aa-order-cards-tab></aa-order-cards-tab>
        }
      </mat-tab>

      <mat-tab label="Invoices">
        <ng-template mat-tab-label>
          <span
            [matBadge]="
              (order$ | async)?.hasPendingServiceChanges ||
              ((order$ | async)?._count?.orderServiceLinkages ?? 0) > 0 ||
              (cardsWithUnsentChanges$ | async)?.length ||
              (cardsWithPendingApproval$ | async)?.length
                ? '~'
                : null
            "
            matBadgeOverlap="false"
            >Invoices</span
          >
        </ng-template>
        @if ((currentTabIndex$ | async) == 1) {
          <aa-order-invoices-tab></aa-order-invoices-tab>
        }
      </mat-tab>

      <mat-tab label="History">
        @if ((currentTabIndex$ | async) == 2) {
          <aa-order-action-logs-tab></aa-order-action-logs-tab>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
